/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var version = window.version;

  var checkwallet = function checkwallet(val) {
    window.wallet = "true";
    $f7.views.main.router.navigate(val);
  };

  $on('pageInit', function () {
    $('.wallet-amount').html("$" + window.wallet_amount);
    window.checkbalance = true;
    $update();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">

    <!-- Top Navbar -->
    <div class="navbar navbar-transparent">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <!-- <div class="left">
          <a href="#" class="link icon-only panel-open" data-panel="left">
            <i class="icon f7-icons">chevron_left</i>
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div> -->                                                                                                                 
        <div class="title sliding">GD Lotaria</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons">text_bubble</i>
            <!-- <i class="icon f7-icons if-not-md">menu</i> -->
            <!-- <i class="icon material-icons if-md">menu</i> -->
          </a>
        </div>
      </div>
    </div>

    <div class="fab fab-extended fab-center-bottom color-maroon button-print">
      <a href="#" class="link back">
        <div class="fab-text print-pay" style="font-size: 18px;">
          <span class='en'>Back</span>
          <span class='cn'>回去</span>
          <span class='tl'>Fila Fali</span>
        </div>
      </a>
    </div>

    <!-- Scrollable page content-->
    <div class="page-content">

      <div style="background-image: url('static/images/longlong.png'); background-repeat: no-repeat;background-size: cover;background-color: var(--f7-theme-color); height: 250px; margin-top: -150px; border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;">
 
      </div>


      
      <div class="block" style="color: white; margin-top: -130px;" >
        
        <table>
          <td width=80px>
            <img src="static/images/gd.png" width=70px style="vertical-align: middle;"/>
          </td>
          <td>
            <H2 style="position:relative; top:-5px">
              <span class='en'>GD Lotaria Agent</span>
              <span class='cn'>GD Lotaria 代理人</span>
              <span class='tl'>Ajente GD Lotaria</span>
            </H2>
            <span style="font-size:16px;position:relative; top:-25px">
              <span class='en'>Good Day</span>
              <span class='cn'>您好</span>
              <span class='tl'>Loron Diak</span>
            ,</span>
          </td>
        </table>

        <div class="row" style="margin-top: -20px;">
          <div class="col-50">
            
          </div>
          <div class="col-50" style="text-align: right;">
            
              <span class='en'>Version </span>
              <span class='cn'>版本</span>
              <span class='tl'>Versaun</span>
            ${version}
          </div>
        </div> 
        <marquee>
          <span class='en'>Have a new number? Be the winner..</span>
          <span class='cn'>有新号码吗？成为赢家..</span>
          <span class='tl'>Iha Numeru Foun? Sai manan nain..</span>
        </marquee>
        
      </div>
      
      <div class="card" style="margin-top: -30px; border-radius: 10px;">
        <table width=100%>
          <thead>
            <tr>
              <th>
                <span class='en'>Wallet Amount</span>
                <span class='cn'>钱包金额</span>
                <span class='tl'>Karteira Barak</span>
              </th>
              <th>

              </th>
              <th style="font-size: 20px;" class="wallet-amount">
                
              </th>
            </tr>
          </thead>
          <tbody>

          </tbody>
        </table>
      </div>

      <div class='.auth'>

      </div>

    
    <br/>
    <div class="block" style="margin-top: 0px;">
      <div class="row">

        <div class="col" style="display: flex;justify-content: center;">
          <a href="#" @click=${() => checkwallet('/gen_buypaper/')}>
          <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">
              <img src="static/images/buypaper.png" width=50px/>
              <br/>
              <span class='en'>Buy Ticket</span>
              <span class='cn'>买票</span>
              <span class='tl'>Sosa Ticket</span>
            </span> 
          </div>
          </a>
        </div>

        <div class="col col-outstanding" style="display: flex;justify-content: center;">
          <a href="#" @click=${() => checkwallet('/gen_payoutstanding/')}>
          <div style="width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">

                <img src="static/images/bill.png" width=50px/>


              
              <br/>
              <span class='en'>Pay My Bill</span>
              <span class='cn'>支付我的账单</span>
              <span class='tl'>Selu ha'u-nia Bill</span>
            </span> 
          </div>
          </a>
          <a href="#" @click=${() => checkwallet('/gen_payoutstanding/')}>
            <span class="badge color-red badge-outstanding" style="position: relative; margin-left:-50px"></span>
          </a>
        </div>

        <div class="col col-topup" style="display: flex;justify-content: center;">
          <a href="#" @click=${() => checkwallet('/gen_buytopup/')}>
          <div style="width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">
              <img src="static/images/topup.png" width=50px/>
              <br/>
              <span class='en'>Topup</span>
              <span class='cn'>充值</span>
              <span class='tl'>Topup</span>
            </span> 
          </div>
          </a>
        </div>
      </div>
    </div>


    <div class="block" style="margin-top: 0px;">
      <div class="row">

        <div class="col" style="display: flex;justify-content: center;">
          <a href="#" @click=${() => checkwallet('/gen_withdraw/')}>
          <div style=" width: 90px;height: 90px;border-radius: 20%; display: flex;align-items: center;justify-content: center;">
            <span style="color: white; text-align: center;">
              <img src="static/images/money_withdrawal.png" width=50px/>
              <br/>
              <span class='en'>Withdraw</span>
              <span class='cn'>提取</span>
              <span class='tl'>Foti</span>
            </span> 
          </div>
          </a>
        </div>

        <div class="col col-outstanding" style="display: flex;justify-content: center;">
          
        </div>

        <div class="col col-topup" style="display: flex;justify-content: center;">
          
        </div>
      </div>
    </div>


    </div>
  </div>
`
    }
    ;
}

framework7Component.id = '75aaf1cb47';
export default framework7Component;